import { defineComponent as _defineComponent } from 'vue'
import {
  BrandImage,
  ContextColorProvider,
  EBrandImageLogos,
  EBrandImageSchemas,
  Heading
} from '@warrenbrasil/nebraska-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'Splash',
  setup(__props) {

const bannerSplash =
  'https://warren.com.br/assets/trade/paid-custody/banner-splash.png';

return { __sfc: true,bannerSplash, BrandImage, ContextColorProvider, EBrandImageLogos, EBrandImageSchemas, Heading }
}

})